import { Link, useLocation } from "react-router-dom";
import classNames from "classnames";
import { Icons } from "./Icons";
import { useRole } from "../lib/auth/useRole";
import { MORE_PATH, isNavActive, navForRole } from "../lib/nav";

export function TabBar() {
  const { pathname } = useLocation();
  const { primary } = navForRole(useRole());
  const moreActive = !primary.some((t) => isNavActive(t, pathname));

  const tabs = [
    ...primary.map((t) => ({ ...t, active: isNavActive(t, pathname) })),
    {
      id: "plus",
      label: "Plus",
      icon: Icons.more,
      path: MORE_PATH,
      active: moreActive,
    },
  ];

  return (
    <nav className="tabbar" aria-label="Navigation principale">
      {tabs.map((t) => (
        <Link
          key={t.id}
          to={t.path}
          className={classNames("tab", { active: t.active })}
          aria-current={t.active ? "page" : undefined}
        >
          <t.icon size={22} sw={t.active ? 2 : 1.7} />
          <span className="lbl">{t.label}</span>
        </Link>
      ))}
    </nav>
  );
}
